// OverflowItem.tsx
import React, { ReactNode, useRef } from 'react';
import { useOverflowContext } from './OverflowContext';

interface OverflowItemProps {
  id: string;
  priority: number;
  position: 'left' | 'right' | 'middle'; // position of the item in the overflow menu
  children: ReactNode; // usually a <button> or whatever
}

export default function OverflowItem({
  id, priority, position, children,
}: OverflowItemProps) {
  const { registerItem, unregisterItem, isVisible } = useOverflowContext();
  const itemRef = useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    registerItem(id, position, priority, itemRef.current);
  }, [id, priority, itemRef.current]);

  React.useEffect(() => () => {
    unregisterItem(id);
  }, [id]);

  if (!isVisible(id)) {
    return null;
  }

  // Wrap children in a <div ref={itemRef}> so we can measure its outer width
  return <div ref={itemRef} style={{ display: 'block', flexShrink: 0 }}>{children}</div>;
}
